import StartupPage from '@/pages/startup'
import type { RouteObject } from 'react-router-dom'

const routes: RouteObject = {
  path: 'verify/:uuid?',
  element: <StartupPage />,
}

export default routes
